import { useEffect } from "react";

const useGlobalEvents = () => {
  useEffect(() => {
    // Token refresh is now handled by the axios interceptor in helpers/auth.js
    // This hook is kept for any future global event handling needs
  }, []);
};

export { useGlobalEvents };
